import React from 'react';

const HomePage = () => {
  return (
    <>
      <div className="container">
        <div className="badge">Under Construction</div>

        <h1>
          We are <br />
          <span className="gradient-text">The Tech Collective.</span>
        </h1>

        <p className="subtitle">
          A group of developers building systems, crafting code, and solving problems.
          Something amazing is about to launch here.
        </p>

        <form className="notify-form"
              name="notify"
              method="POST"
              data-netlify="true"
              action="/success">

            <input type="hidden" name="form-name" value="notify" />

            <input type="email" name="email" placeholder="Enter your email for updates" required />
            <button type="submit">Notify Me</button>
        </form>
      </div>

      <footer>
        &copy; 2023 The Tech Collective. All rights reserved.
      </footer>
    </>
  );
};

export default HomePage;
